<ion-header>
  <ion-toolbar>
    <ion-title [innerHTML]="(runId ? 'SCENARIOS.RUN.LOGS' : 'SCENARIOS.RUN.RUN_MANUALLY') | translate"></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div *ngIf="!runId">
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.RUN.CHOOSE_STORE' | translate"></ion-label>
    <ng-select
      autofocus
      class="autocomplete"
      bindLabel="name"
      bindValue="id"
      [items]="stores$ | async"
      [placeholder]="'SCENARIOS.RUN.CHOOSE_STORE_PLACEHOLDER' | translate"
      [(ngModel)]="selectedStoreId"
    ></ng-select>
  </div>

  <div class="logs">
    <div class="logs__container">
      <ion-spinner *ngIf="loading$ | async" name="crescent" color="light"></ion-spinner>
      <ion-list class="logs__container__list">
        <ion-item
          *ngFor="let log of logs$ | async"
          class="logs__container__list__item"
          lines="none"
          [class.--error]="log.severity === severities.Error"
          [class.--warning]="log.severity === severities.Warning"
        >
          <span class="--date">{{ log.createdAt | date:'dd.MM.yyyy HH:mm:ss SSS' }}</span>
          <span class="--context">[{{ log.context }}]</span>
          <span class="--debug">{{ log.log }}</span>
        </ion-item>
      </ion-list>

      <ion-infinite-scroll
        [disabled]="(currentLogsTotalPages$ | async) <= (currentLogsPage$ | async)"
        (ionInfinite)="loadMoreLogs($any($event))"
      >
        <ion-infinite-scroll-content color="primary" loadingText="Laden..."></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-button class="button --small --dark-outline" [innerHTML]="'BUTTONS.CANCEL' | translate" (click)="dismiss()"></ion-button>
  <ion-button
    *ngIf="!runId"
    class="button --small --success"
    [disabled]="!selectedStoreId || (loading$ | async)"
    [innerHTML]="'SCENARIOS.PLAY' | translate"
    (click)="runScenario()"
  ></ion-button>
</ion-footer>
